import { useQueryTableStore } from "@/components/query-table/stores/onlySelectedViewStore";
import {
  DataTableOnlySelectedViewMode,
  dataTableOnlySelectedViewModes,
} from "@/types/dataTableSettings";
import { useCallback } from "react";

export function useOnlySelectedMode({
  tableName,
  enabled,
}: {
  tableName: string;
  enabled: boolean;
}) {
  const setOnlySelectedMode = useQueryTableStore((s) => s.setMode);
  const mode = useQueryTableStore(
    (s) => s.modesByTable[tableName] ?? dataTableOnlySelectedViewModes.all,
  );

  const onModeChange = useCallback(
    (value: string) => {
      if (!enabled) return;
      const nextMode: DataTableOnlySelectedViewMode =
        value === dataTableOnlySelectedViewModes.selected
          ? dataTableOnlySelectedViewModes.selected
          : dataTableOnlySelectedViewModes.all;
      setOnlySelectedMode(tableName, nextMode);
    },
    [enabled, setOnlySelectedMode, tableName],
  );

  const resetToAll = useCallback(() => {
    if (!enabled) return;
    setOnlySelectedMode(tableName, dataTableOnlySelectedViewModes.all);
  }, [enabled, setOnlySelectedMode, tableName]);

  return { mode, onModeChange, resetToAll };
}
